import { defineMessages } from 'react-intl'

export default defineMessages({
  addAnother: {
    defaultMessage: 'Add another',
    description: 'share assets form | add another button label',
  },
  assetName: {
    defaultMessage: 'Asset name',
    description: 'share assets form | asset name table column',
  },
  assetSelectAddNew: {
    defaultMessage: 'Add New Asset',
    description: 'share assets form | asset select add new option label',
  },
  assetSelectLabel: {
    defaultMessage: 'Select Assets to Share *',
    description: 'share assets form | select assets field label',
  },
  assetSelectPlaceholder: {
    defaultMessage: 'Please Select',
    description: 'share assets form | asset select placeholder',
  },
  cost: {
    defaultMessage: 'Cost',
    description: 'share assets form | cost table column, total cost text',
  },
  datesRequiredValidation: {
    defaultMessage: 'Start and end date fields are required',
    description: 'share assets form | date from and to required validation error',
  },
  referenceMaxLengthValidation: {
    defaultMessage: 'Must be at most 60 characters',
    description: 'share assets form | reference max length validation error',
  },
  duration: {
    defaultMessage: 'Duration',
    description: 'share assets form | duration table column',
  },
  durationCustom: {
    defaultMessage: 'Custom',
    description: 'share assets form | duration custom option label and tooltip key',
  },
  durationCustomDescription: {
    defaultMessage:
      'Select a Share duration that starts at 00:00 of the start day until 23:59 of the end day.',
    description: 'share assets form | duration custom instant label',
  },
  durationInstant: {
    defaultMessage: 'Instant',
    description: 'share assets form | duration custom instant label and tooltip key',
  },
  durationInstantDescription: {
    defaultMessage: 'Vehicle location data will be Shared immediately, until 23:59 tonight.',
    description: 'share assets form | duration custom instant label',
  },
  formGeneralError: {
    defaultMessage: 'Adjust form fields and try again',
    description: 'share assets form | general error above the form',
  },
  formErrorSummaryTitle: {
    // Only ever shown for two or more errors — a lone error is rendered as its own message.
    defaultMessage: '{count} problems to fix',
    description: 'share assets form | heading above the list of form errors',
  },
  loading: {
    defaultMessage: 'Loading...',
    description: 'share assets form | loading assets text',
  },
  organizationToAddNew: {
    defaultMessage: 'Add a New Contact',
    description: 'share assets form | target organization add new option label',
  },
  organizationToLabel: {
    defaultMessage: 'Who are you sharing with',
    description: 'share assets form | target organization field label',
  },
  organizationToPlaceholder: {
    defaultMessage: 'Please Select a Contact',
    description: 'share assets form | target organization field placeholder',
  },
  organizationContactToLabel: {
    defaultMessage: 'Select contact for ...',
    description: 'share assets modal | target organization contact field label',
  },
  organizationContactToPlaceholder: {
    defaultMessage: 'Please Select a Contact',
    description: 'share assets form | target organization field placeholder',
  },
  organizationContactFromLabel: {
    defaultMessage: 'Select your contact for this share',
    description: 'share assets modal | target organization contact field label',
  },
  organizationContactFromPlaceholder: {
    defaultMessage: 'Please Select a Contact',
    description: 'share assets form | target organization field placeholder',
  },
  remove: {
    defaultMessage: 'Remove',
    description: 'share assets form | remove table column',
  },
  sendButton: {
    defaultMessage: 'Next',
    description: 'share assets form | form send button label',
  },
  sharedWith: {
    defaultMessage: 'with',
    description: 'assets shared successfully modal | with <organization>',
  },
  subtitle: {
    defaultMessage: 'Create or manage a Smart Share',
    description: 'share assets form | modal subtitle',
  },
  contactSelectSubtitle: {
    defaultMessage: 'Select contact details for your Smart Share. These fields are optional.',
    description: 'share contact select form | modal subtitle',
  },
  extendShareSubtitle: {
    defaultMessage: 'Extend Smart Share',
    description: 'share assets form | modal subtitle',
  },
  summaryModalTitle: {
    defaultMessage: 'Assets shared successfully',
    description: 'assets shared successfully modal | title',
  },
  extendModalTitle: {
    defaultMessage: 'Extend (Step 1/2)',
    description: 'extend assets form | modal title',
  },
  contactSelectModalTitle: {
    defaultMessage: 'Share your Assets (Step 3/3)',
    description: 'extend assets form | modal title',
  },
  extendContactSelectModalTitle: {
    defaultMessage: 'Extend (Step 2/2)',
    description: 'extend assets form | modal title',
  },
  title: {
    defaultMessage: 'Share your Assets (Step 2/3)',
    description: 'share assets form | modal title',
  },
  onwardShareModalTitle: {
    defaultMessage: 'Onward Share This Asset (Step 1/2)',
    description: 'onward share assets form | modal title',
  },
  onwardShareContactSelectModalTitle: {
    defaultMessage: 'Onward Share This Asset (Step 2/2)',
    description: 'onward share assets form | modal title',
  },
  selectShareClassModalTitle: {
    defaultMessage: 'Share your Assets (Step 1/3)',
    description: 'select share class form | modal title',
  },
  selectShareClassSubtitle: {
    defaultMessage: 'Choose how you want to make your assets available to your contact',
    description: 'select share class form | modal subtitle',
  },
  selectShareClassLabel: {
    defaultMessage: 'Select Share Type',
    description: 'select share class form | share type field label',
  },
  selectShareClassInfoLabel: {
    defaultMessage: 'More about share types',
    description: 'select share class form | share type info tooltip trigger label',
  },
  selectShareClassSmartShareInfo: {
    defaultMessage:
      "An asset in a Smart Share is visible on your contact's map and their asset list.",
    description: 'select share class form | smart share info tooltip text',
  },
  selectShareClassDelegateInfo: {
    defaultMessage:
      'A delegated vehicle is made available to a contact to select during task assignment. The vehicle position is only visible when the task is in progress.',
    description: 'select share class form | delegate info tooltip text',
  },
  smartShareClassTitle: {
    defaultMessage: 'Smart Share',
    description: 'select share class form | smart share card title',
  },
  smartShareClassDescription: {
    defaultMessage:
      "Share an asset with a contact for a duration you choose. The asset is visible on your contact's map and their asset list for as long as the Smart Share is active.",
    description: 'select share class form | smart share card description',
  },
  delegateShareClassTitle: {
    defaultMessage: 'Delegate Vehicle',
    description: 'select share class form | delegate card title',
  },
  delegateShareClassDescription: {
    defaultMessage:
      'A delegated vehicle is made available to a contact to select during task assignment. The vehicle position is only visible when the task is in progress.',
    description: 'select share class form | delegate card description',
  },
  delegateModalTitle: {
    defaultMessage: 'Delegate Vehicle (Step 2/3)',
    description: 'delegate assets form | modal title',
  },
  delegateContactSelectModalTitle: {
    defaultMessage: 'Delegate Vehicle (Step 3/3)',
    description: 'delegate assets form | contact select modal title',
  },
  delegateSubtitle: {
    defaultMessage: 'Delegate a vehicle to a contact for use in tasks',
    description: 'delegate assets form | modal subtitle',
  },
  to: {
    defaultMessage: 'To',
    description: 'share assets form | to date text',
  },
})
